import { DriveFolderUpload } from "@mui/icons-material";
import { Box, Divider, Stack } from "@mui/material";
import { TemplateFieldType } from "../../../App/Enums/TemplateFieldType";
import { MemoTextTemplateListDialog } from "../../MessageTemplates/TextTemplateListDialog";
import { MessageCalendarOptions } from "../../SendGroupMessage/Components/MessageCalendarOptions/MessageCalendarOptions";
import MessageTemplateFields from "../../SendGroupMessage/Components/MessageTemplateFields/MessageTemplateFields";
import { MessageActionButton } from "../../SendGroupMessage/Components/SharedComponents/MessageActionButton";
import PendingMessageQueue from "../../SendGroupMessage/Components/SharedComponents/PendingMessageQueue";
import TextMessageInput from "../../SendGroupMessage/Components/SharedComponents/TextMessageInput";
import { SendMessagesMutationState } from "../State/useMessageMutationState";
import useMessageSendState from "../State/useMessageSendState";
import { ToggleNotificationAlerts } from "./ToggleNotificationAlerts";

export function TextMessageSchedule({
  selectedCandidatesCount,
  messageMutationState,
  notifyMe,
  setNotifyMe,
}: {
  selectedCandidatesCount: number;
  messageMutationState: SendMessagesMutationState;
  notifyMe: boolean;
  setNotifyMe: (value: boolean) => void;
}) {
  const {
    getters: {
      disableScheduleAction,
      disableAddToQueueAction,
      scheduleMessagesTooltipText,
      disabledScheduleMessagesTooltipText,
      addButtonTooltipText,
      postSendMessageIsLoading,
      upsertMessageTemplateLoading,
    },
    handlers: { handleScheduleMessages },
  } = useMessageSendState(messageMutationState);

  return (
    <Box>
      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent="flex-end"
        divider={<Divider orientation="vertical" flexItem />}
        spacing={2}
        sx={{ transform: "translateY(-0.5em)" }}
      >
        <MemoTextTemplateListDialog
          ButtonProps={{ startIcon: <DriveFolderUpload /> }}
          buttonName={"Load Text Templates"}
        />
        <MessageTemplateFields excludedTypes={[TemplateFieldType.Email, TemplateFieldType.Forms]} />
      </Stack>
      <Box>
        <TextMessageInput disabledInput={upsertMessageTemplateLoading || postSendMessageIsLoading} />
        <Box style={{ marginTop: "20px" }}>
          <MessageCalendarOptions
            addButtonTooltipText={addButtonTooltipText}
            disableAddToQueueAction={disableAddToQueueAction}
          />
        </Box>
      </Box>
      <Stack spacing={2} direction="column" alignItems="flex-start" width="100%">
        <PendingMessageQueue />
        <MessageActionButton
          buttonText="Schedule Messages"
          disableButton={disableScheduleAction}
          tooltipText={scheduleMessagesTooltipText}
          disabledTooltipText={disabledScheduleMessagesTooltipText}
          data-test="schedule-message-button"
          isGroup={false}
          onClick={handleScheduleMessages}
          sendCount={selectedCandidatesCount}
          sx={{ width: "100%" }}
          showCount={false}
          ToggleNotificationAlerts={
            <ToggleNotificationAlerts
              notifyMe={notifyMe}
              setNotifyMe={setNotifyMe}
              disableNotificationToggle={false}
              isMultiMessage={true}
            />
          }
        />
      </Stack>
    </Box>
  );
}
